<section class="insights-index-hero" aria-labelledby="insights-page-title">
  <div class="insights-hero-inner">
    <p class="section-kicker"><span></span>Pavillion Properties</p>
    <h1 id="insights-page-title">News &amp; Insights</h1>

    <div class="insights-filter-bar" aria-label="Filter news posts">
      <label class="insights-search">
        <svg class="material-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24">
          <path
            d="M9.5 4a5.5 5.5 0 0 1 4.38 8.83l4.65 4.64-1.06 1.06-4.64-4.65A5.5 5.5 0 1 1 9.5 4Zm0 1.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
          />
        </svg>
        <input
          type="search"
          placeholder="Search headlines"
          [value]="searchQuery"
          (input)="updateSearch($event)"
        />
      </label>
      <label>
        <span>Category</span>
        <select [value]="selectedCategory" (change)="updateCategory($event)">
          <option value="all">All categories</option>
          @for (category of categories(); track category) {
            <option [value]="category">{{ category }}</option>
          }
        </select>
      </label>
      <label>
        <span>Year</span>
        <select [value]="selectedYear" (change)="updateYear($event)">
          <option value="all">All years</option>
          @for (year of years(); track year) {
            <option [value]="year">{{ year }}</option>
          }
        </select>
      </label>
    </div>
  </div>
</section>

<section class="section insights-list-section" aria-labelledby="latest-news-title">
  <div class="insights-list-heading">
    <h2 id="latest-news-title">Latest News</h2>
    @if (!blogLoading && !blogError) {
      <p>{{ filteredPosts().length }} articles</p>
    }
  </div>

  @if (blogLoading) {
    <div class="insights-state">
      <h2>Loading insights</h2>
      <p>Fetching published posts from Django.</p>
    </div>
  } @else if (blogError) {
    <div class="insights-state">
      <h2>Insights are unavailable</h2>
      <p>Please check back shortly.</p>
    </div>
  } @else if (filteredPosts().length) {
    <div class="news-card-grid">
      @for (post of filteredPosts(); track post.id) {
        <button class="news-card" type="button" (click)="blogPostSelected.emit(post)">
          @if (post.cover_image_url) {
            <img [src]="post.cover_image_url" [alt]="post.title + ' cover image'" />
          } @else {
            <div class="blog-image-placeholder" aria-hidden="true"></div>
          }
          <span class="blog-meta">{{ postMeta(post) }}</span>
          <h3>{{ post.title }}</h3>
          <p>{{ post.excerpt }}</p>
        </button>
      }
    </div>
  } @else {
    <div class="insights-state">
      <h2>No matching insights</h2>
      <p>Try a different search, category, or year.</p>
    </div>
  }
</section>
